﻿{
  "community": {
    "name": "Społeczność",
    "titles": {
      "1": "Społeczność online",
      "2": "Wyszukuj materiały",
      "3": "Udostępniaj swoją twórczość"
    },
    "body": {
      "1": "Świetnie miejsce, w którym można sprawdzić całą ofertę Boardmaker",
      "2": "Zobacz, co inni tworzą i udostępniają. To jak okno na świat Boardmaker Magic!",
      "3": "Korzystając z preferowanego oprogramowania Boardmaker prześlij i udostępnij społeczności efekty swojej pracy"
    }
  },
  "personal": {
    "name": "Subskrypcja osobista",
    "header": "Obejmuje całą społeczność, a także:",
    "titles": {
      "1": "Twórz, edytuj, odtwarzaj i drukuj",
      "2": "Oprogramowanie Boardmaker"
    },
    "body": {
      "1": "Dla rodzica lub opiekuna z jednym dzieckiem, który chce tworzyć, edytować, odtwarzać lub drukować materiały",
      "2": "Do konta jest dołączona licencja Boardmaker 7, którą można zainstalować na maks. dwóch komputerach z systemem Windows"
    }
  },
  "professional": {
    "name": "Subskrypcja profesjonalisty",
    "header": "Obejmuje subskrypcję osobistą, a także:",
    "titles": {
      "1": "Zarządzanie uczniami",
      "2": "Zindywidualizowane ustawienia"
    },
    "body": {
      "1": "Dla instruktorów z 1 do 50 uczniów, którzy chcą przydzielać zadania i śledzić dane uczniów",
      "2": "Personalizowane ustawienia dostępu dla poszczególnych uczniów"
    }
  },
  "organization": {
    "name": "Subskrypcja instytucjonalna",
    "header": "Obejmuje subskrypcję profesjonalisty, a także:",
    "titles": {
      "1": "Wsparcie zespołu multidyscyplinarnego"
    },
    "body": {
      "1": "Cennik licencji, organizacja kontroluje informacje i wiele osób można przypisać do tych samych uczniów"
    }
  }
}
